import React from 'react';
import styled from 'styled-components';

export const PaneBody = ({ children, ...props }) => {
  return <Container {...props}>{children}</Container>;
};

const Container = styled.article`
  flex: 1;
  display: flex;
  flex-direction: column;
`;
